import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import Header from "../home/header";
import ProductItem from "./product_item";
import UTILS from "../../utils/commons";
import Login from "../home/login_form";
import { ApiClient } from "../../utils/api-client";
import Loading from "../home/Loading";
import PaginationControl from "../home/pagination_control";
const ProductList = ( props ) => {
    var location = useLocation();
    let navigate = useNavigate();
    const loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
    const apiClient = new ApiClient( loginState ? loginState.accessToken : null );
    const [ products, setProducts ] = useState( [] );
    const [ filteredProducts, setFilteredProducts ] = useState( products );
    const [ loading, setLoading ] = useState( false );
    const [ currentPage, setCurrentPage ] = useState( 1 );
    const [ pageSize, setPageSize ] = useState( UTILS.DEFAULT_PAGE_SIZE );
    const [ totalPages, setTotalPages ] = useState( Math.ceil( filteredProducts.length / pageSize ) );
    const [ hasNextPage, setHasNextPage ] = useState( false );
    const [ hasPreviousPage, setHasPreviousPage ] = useState( false );

    const loadProducts = async ( page = 1, limit = pageSize ) => {
        setLoading( true );
        try {
            const apiResponse = await apiClient.get( 'products', {
                params: {
                    page,
                    limit
                }
            } );
            const productsData = apiResponse.data.data;
            setProducts( productsData );
            setFilteredProducts( productsData );
            setTotalPages( apiResponse.data.totalPages );
            setCurrentPage( apiResponse.data.page );
            setHasNextPage( apiResponse.data.hasNextPage );
            setHasPreviousPage( apiResponse.data.hasPreviousPage );
            setPageSize( apiResponse.data.limit );

        }
        catch ( error ) {
            setProducts( [] );
            setFilteredProducts( [] );
            console.error( "Error fetching products:", error );
        }
        setLoading( false );
    }
    useEffect( () => {
        loadProducts();
    }, [] );
    const confirmDelete = async ( itemId ) => {
        let message = "Are you sure you want to delete this product?";
        if ( window.confirm( message ) ) {

            await deleteProduct( itemId )
        }
    }

    const deleteProduct = async ( pid ) => {
        const response = await apiClient.delete( `products/${pid}` );
        if ( response.status === 200 ) {
            //refresh list
            loadProducts();
        }
        else {
            alert( "Failed to delete product" );
        }
    }
    const handlePageChange = ( page ) => {
        loadProducts( page, pageSize );
    }
    const handlePageSizeChange = ( pageSize ) => {
        loadProducts( 1, pageSize );
    }
    if ( loginState ) {
        return ( <>
            <Header auth={loginState} />
            <section className="flex justify-start items-start">
                <div className="container">
                    <div className="action-wide rounded-xl border border-gray-200 bg-gradient-to-r from-white to-gray-50 p-4 md:p-5">
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                            <div>
                                <p className="text-sm uppercase tracking-wide text-gray-500">Catalog</p>
                                <p className="text-2xl font-semibold text-gray-800">Products</p>
                            </div>
                            <div className="w-full md:w-auto flex flex-col md:flex-row items-stretch md:items-center gap-3">
                                <input className="w-full md:w-80 px-3 py-2 focus:outline-none rounded-md border border-gray-300 focus:ring-2 focus:ring-gray-300" type="text" placeholder="Search by name or pack size..." onChange={( e ) => {
                                    let keyword = e.target.value.toLowerCase();
                                    let filteredResults = products.filter( p => p.productName.toLowerCase().includes( keyword ) || p.packSize.toLowerCase().includes( keyword ) );
                                    setFilteredProducts( filteredResults );
                                }} />
                                <button className="btn bg-success md:min-w-[7rem]" onClick={() => navigate( "/products/new", { replace: false } )}>Add Product</button>
                            </div>
                        </div>
                        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
                            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
                                <p className="text-xs uppercase tracking-wide text-gray-500">Visible Products</p>
                                <p className="text-lg font-semibold text-gray-800 mt-1">{filteredProducts.length}</p>
                            </div>
                            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
                                <p className="text-xs uppercase tracking-wide text-gray-500">Total Loaded</p>
                                <p className="text-lg font-semibold text-gray-800 mt-1">{products.length}</p>
                            </div>
                        </div>
                    </div>
                    {loading ? ( <Loading className="mx-auto mt-16" /> ) : (
                        <div className="mt-12">{filteredProducts.length > 0 ? <PaginationControl pageSize={pageSize} currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} onPageSizeChange={handlePageSizeChange} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} /> : null}
                            <div className="border-t border-gray-200 pt-4 grid md:grid-cols-2 xl:grid-cols-3 gap-3 md:justify-start md:items-center flex-wrap" id="list_container">
                                {filteredProducts.length > 0 ? (
                                    filteredProducts.map( p => {
                                        return <ProductItem data={p} key={p.id} onDelete={() => confirmDelete( p.id )} onClick={() => { navigate( "/products/view/" + p.id, { replace: false, state: p } ) }} onEdit={() => { navigate( '/products/edit/' + p.id, { replace: false, state: { product: p } } ) }} />
                                    } )

                                ) : <div className="col-span-full rounded-lg border border-dashed border-gray-300 bg-gray-50 px-4 py-10 text-center text-gray-500">No products found.</div>
                                }
                            </div>
                        </div>
                    )}</div>
            </section>
        </> )
    }
    else {
        return <Login target="/products" />
    }
}
export default ProductList;